<template>
  <AddPlaceForm :lat="lat" :long="long"/>
</template>

<script>
  import AddPlaceForm from "../components/AddPlaceForm";

  export default {
    name: 'AddPlace',
    props: ['lat', 'long'],
    components: {
      AddPlaceForm,
    }
  }
</script>
